import { render, staticRenderFns } from "./save-ok.vue?vue&type=template&id=62b75616&scoped=true&"
import script from "./save-ok.vue?vue&type=script&lang=js&"
export * from "./save-ok.vue?vue&type=script&lang=js&"
import style0 from "./save-ok.vue?vue&type=style&index=0&id=62b75616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b75616",
  null
  
)

export default component.exports